/* Set the width of the side navigation to 250px */

var mileslimit = [];
var homeAndRetail = [];
var business = [];

var self = this;  
var latLongArray = [];
var storeAddress = [];
var storeFlag = false;
var zoomLevel =8;
var currentMiles;
var inHome = false;

var zip, latitude, longitude;

function milesChangeHandler(){

}

function helpHandler(data,index){
  $("#myModal"+index).modal("show");
}

function deg2rad(deg) {
return deg * (Math.PI / 180);
}

var qs = (function(a) {
  if (a == "") return {};
  var b = {};
  for (var i = 0; i < a.length; ++i)
  {
      var p=a[i].split('=', 2);
      if (p.length == 1)
          b[p[0]] = "";
      else
          b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
  }
  return b;
})(window.location.search.substr(1).split('&'));

function filterDuplicates(data) {
    var obj = {};
    for ( var i=0, len=data.length; i < len; i++ )
        obj[data[i]['id']] = data[i];

    data = [];
    for ( var key in obj )
        data.push(obj[key]);
    return data;
}

function checkAndFetchStoreDetails() {
  var postalCode = zip
  zip = "";
  if(inHome) {
    $.ajax({
      type: 'GET',
      url: serviceUrl + "/search/store?q=fq=(locationTypes:%22In-Home%22)",
      dataType: 'json',
      success: function(json){
        var urldata = window.location.search;
        if((urldata.indexOf("&") !== -1) && (urldata.indexOf("=") !== -1)){
        var tempMap = urldata.split('=');
        var code = tempMap[1].split('&');
        currentMiles = qs['radius'];
        $("#selectDropdown").val(currentMiles);
        if (json.response.docs.length > 0){
          var i,j;
          var postalcodeArr = [];
          var milesArr = [];
          var lat2 = latitude;
          var lon2 = longitude;
          for (i=0; i < json.response.docs.length; i++){
            if(json.response.docs[i].active[0] === true){
              var lat1 = json.response.docs[i].latitude;
              var lon1 = json.response.docs[i].longitude;
              // Get the Distance in KM based on Latitude and Longitude
              getDistanceFromLatLonInKm = function(lat1, lon1, lat2, lon2) {
                    var R = 3959; // Radius of the earth in miles
                    var dLat = deg2rad(lat2 - lat1); // deg2rad below
                    var dLon = deg2rad(lon2 - lon1);
                    var a =
                        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                        Math.sin(dLon / 2) * Math.sin(dLon / 2);
                    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                    var miles = R * c; // Distance in miles
                    if(Math.round(miles) <= currentMiles && json.response.docs[i].locationTypes[0] != "In-Home"){
                        json.response.docs[i].distance = miles.toFixed(1) * 1;
                        milesArr.push(json.response.docs[i]);
                    }
                    return miles.toFixed(1) * 1;
              }
              getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2);
              var zipCheck = json.response.docs[i].zip;
              if(zipCheck && zipCheck[0] !== "" && zipCheck[0] === postalCode) {
                postalcodeArr.push(json.response.docs[i]);  
              }

              var zipsWrap = json.response.docs[i].zips;
              if(json.response.docs[i].hasOwnProperty("zips") && zipsWrap[0] !== " "){
                for(j=0; j < zipsWrap.length; j++){
                    if(zipsWrap[j].indexOf(postalCode) !== -1){
                      //if( zipsWrap[j].indexOf(',') ){
                      var commavalue = zipsWrap[j];
                        if(commavalue === postalCode && json.response.docs[i].locationTypes[0] != "Retail"){
                            postalcodeArr.push(json.response.docs[i]);
                        }
                      //}
                    }
                }
              }
            }
          }

          if(postalcodeArr.length > 0 || milesArr.length > 0){
             var mergedArr = postalcodeArr.concat(milesArr);
             mergedArr = filterDuplicates(mergedArr);
              mileslimit = mergedArr;
          for(var i=0; i < mileslimit.length; i++) {
            latLongArray.push(new google.maps.LatLng(mileslimit[i].latitude,mileslimit[i].longitude));
            storeAddress.push(mileslimit[i]);
            console.log("1"+mileslimit[i].locationTypes);
            if(mileslimit[i].locationTypes == "Business"){
              business.push(mileslimit[i]);
            } else{
              homeAndRetail.push(mileslimit[i]);
            }
          }
          if(mileslimit.length > 0){
              storeFlag = true;
              initMap();
          }
          if(homeAndRetail.length > 0) {
            var inHomeItem = buildLocationObj(homeAndRetail[0])
            window.location.href = "/pages/schedule-in-home?location=" + inHomeItem.url;
          }
          if(homeAndRetail.length === 0 && business === 0) {
            $("#no-stores").removeClass('hide');
            $('.searchStores').addClass('show');
          } else {
            //$("#no-stores").hide()
            $("#no-stores").addClass('show')
          }
          buildHomeAndRetailStoreDetails(homeAndRetail);
          buildBusinessStoreDetails(business);
          } else {
            //$("#no-stores").show();
            $("#no-stores").removeClass('hide');
            $('.searchStores').hide();
          }
        }
      }
      },
      error: function(status){
          console.log(status);
      }
  });
} else {
  $.ajax({
    type: 'GET',
    url: serviceUrl + "/search/store?q=*",
    dataType: 'json',
    success: function(json){
      var urldata = window.location.search;
      if((urldata.indexOf("&") !== -1) && (urldata.indexOf("=") !== -1)){
      var tempMap = urldata.split('=');
      var code = tempMap[1].split('&');
      currentMiles = qs['radius'];
      $("#selectDropdown").val(currentMiles);
      if (json.response.docs.length > 0){
        var i,j;
        var postalcodeArr = [];
        var milesArr = [];
        var lat2 = latitude;
        var lon2 = longitude;
        for (i=0; i < json.response.docs.length; i++){
          if(json.response.docs[i].active[0] === true){
            var lat1 = json.response.docs[i].latitude;
            var lon1 = json.response.docs[i].longitude;
            // Get the Distance in KM based on Latitude and Longitude
            getDistanceFromLatLonInKm = function(lat1, lon1, lat2, lon2) {
                    var R = 3959; // Radius of the earth in miles
                    var dLat = deg2rad(lat2 - lat1); // deg2rad below
                    var dLon = deg2rad(lon2 - lon1);
                    var a =
                        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                        Math.sin(dLon / 2) * Math.sin(dLon / 2);
                    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                    var miles = R * c; // Distance in miles
               
                    if(Math.round(miles) <= currentMiles && json.response.docs[i].locationTypes[0] != "In-Home"){
                        json.response.docs[i].distance = miles.toFixed(1) * 1;
                        milesArr.push(json.response.docs[i]);
                    }
                    return miles.toFixed(1) * 1;
              }
            getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2);
            var zipCheck = json.response.docs[i].zip;
              if(zipCheck && zipCheck[0] !== "" && zipCheck[0] === postalCode) {
                postalcodeArr.push(json.response.docs[i]);  
              }
              var zipsWrap = json.response.docs[i].zips;
              if(json.response.docs[i].hasOwnProperty("zips") && zipsWrap[0] !== " "){
                for(j=0; j < zipsWrap.length; j++){
                    if(zipsWrap[j].indexOf(postalCode) !== -1){
                      //if( zipsWrap[j].indexOf(',') ){
                      var commavalue = zipsWrap[j];
                        if(commavalue === postalCode && json.response.docs[i].locationTypes[0] != "Retail"){
                            postalcodeArr.push(json.response.docs[i]);
                        }
                      //}
                    }
                }
              }
          }
        }
        if(postalcodeArr.length > 0 || milesArr.length > 0){
          var mergedArr = postalcodeArr.concat(milesArr);
        mergedArr = filterDuplicates(mergedArr);
        mileslimit = mergedArr;
        for(var i=0; i < mileslimit.length; i++) {
          latLongArray.push(new google.maps.LatLng(mileslimit[i].latitude,mileslimit[i].longitude));
          storeAddress.push(mileslimit[i]);
          //console.log(mileslimit[i].locationTypes+"---"+storeAddress);
          if(mileslimit[i].locationTypes == "Business"){
            business.push(mileslimit[i]);
          } else{
            homeAndRetail.push(mileslimit[i]);
          }
        }
        if(mileslimit.length > 0){
            storeFlag = true;
            initMap();
        }
        if(homeAndRetail.length === 0 && business.length === 0) {
          //$("#no-stores").show()
          $("#no-stores").removeClass('hide');
          $('.searchStores').hide();
        } else {
          //$("#no-stores").hide()
          $("#no-stores").addClass('hide');
          if(homeAndRetail.length === 0 &&  business.length != 0) {
            toggleStores('business');
          }
        }
        if(qs['isSchedulerRedirect']) {
          buildHomeAndRetailStoreDetails(homeAndRetail);
          $("#commercialBtn").hide();
          $("#residentialBtn").hide();
        } else {
          buildHomeAndRetailStoreDetails(homeAndRetail);
          buildBusinessStoreDetails(business);
        }
        if(qs['isCommercialSearch']) {
          toggleStores('business');
        }
        } else {
          //$("#no-stores").show();
          $("#no-stores").removeClass('hide');
          $('.searchStores').hide();
        }
      }
    }
    },
    error: function(status){
        console.log(status);
    }
});
}
}

function findLocation() {
  $.post("https://www.googleapis.com/geolocation/v1/geolocate?key="+googleKey, function(data) { 
    latitude = data.location.lat;
    longitude = data.location.lng;
    var latlng = new google.maps.LatLng(latitude, longitude);
    const geo = new google.maps.Geocoder;
    geo.geocode({'latLng': latlng}, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          zip = getPostalCode(results[0]);
          console.log('zip='+zip, latitude, longitude);
          if(zip !== "") {
            checkAndSubmitForm();
          } else {
            alert("Geocoder could not find postal code, Please enter your zip code or City and State");
          }
        } else {
          alert("Geocoder failed due to: " + status);
        }
    });

  });
}

$("body").delegate("#useMyLocation", "click", function(){
  if(qs['isCommercialSearch']) {
    var input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", "isCommercialSearch");
    input.setAttribute("value", "true");
    document.getElementById("locationSearch").appendChild(input);
  }
  findLocation();
});

$("body").delegate("#selectDropdown", "change", function(){
  checkAndSubmitForm();
});

           
$("body").delegate(".blueBtn", "click", function(){
  var elmId = $(this).attr("id");
  for(var i=0; i< mileslimit.length; i++){
      if(elmId == "blueBtn"+i){
        $("#blueBtn"+i).hide();
        $("#greenBtn"+i).show();
      }
      else{
        $("#blueBtn"+i).show();
        $("#greenBtn"+i).hide();
      }
  }
 
});


$("body").delegate("#blueBtn", "click", function(){
  $("#blueBtn").css("display" , "none");
  $("#greenBtn").fadeIn(500);
});

$(document).ready(function(){
  if(window.location.href.indexOf('?invalid=true')!== -1){
    $('.searchStores').removeClass('hide');
    $("#no-stores").addClass('hide');
  }
  
  if(window.location.href.indexOf('locations/search') !== -1) {
      zip = qs['zip'] ? qs['zip'] : "";
      inHome = qs['isHomeSearch'] ? qs['isHomeSearch'] : false;
      latitude = qs['latitude'];
      longitude = qs['longitude'];
      if(zip !== "") {
        $("#selectedaddress").html(zip);
        $("#address").val(zip);
      }
      checkAndFetchStoreDetails();
  }
});

function initMap() {
    var mapProp = {
    center: latLongArray[0],
    zoom:zoomLevel,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    scaleControl: true
  };
  var map = new google.maps.Map(document.getElementById("gMap"),mapProp);
      if(mileslimit.length > 0) {
          if(storeFlag){
        for(var i=0; i < mileslimit.length;i++){
          var storeName = storeAddress[i].locationName[0];
          //console.log(storeName);
          var marker = new google.maps.Marker({
            position: latLongArray[i],
            map: map,
            title: storeName,//'Click to zoom',
            clickable: true,
            optimized: false,
            animation: google.maps.Animation.DROP
            });
           attachMessage(marker, i, map);
           }
          }
      } else {
        var defaultMapProp = {
          center: new google.maps.LatLng(37.09024,-95.712891),
          zoom:4,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          scaleControl: true
        };
        map = new google.maps.Map(document.getElementById("gMap"),defaultMapProp);
      }
  
}

function attachMessage(marker, number, map) {
  if(storeAddress.length > 0) {
    if (storeAddress[number].locationTypes != "In-Home"){
      var content = '<div align="left"><strong>'+storeAddress[number].locationName+'</strong><br>'+storeAddress[number].address+'<br>'+storeAddress[number].city+'</div>'
    }
    else{
      var content = '<div align="left"><strong>'+storeAddress[number].locationName+'</strong><br>'+storeAddress[number].locationTypes+'<br>'+storeAddress[number].city+'</div>'
    }
    
    var infowindow = new google.maps.InfoWindow(
      { content: content
      });
      google.maps.event.addListener(marker, 'click', function() {
      infowindow.open(map,marker);
    });
  }
}

function buildLocationObj(locationItem) {
  var urlName = "Schedule a store visit";
  if(locationItem.locationTypes.indexOf("In-Home") != -1) {
    urlName = "Schedule an in-home consultation";
  } else if(locationItem.locationTypes.indexOf("Virtual") != -1) {
    urlName = "Schedule a virtual appointment";
  } 
  
  var locationObj = {
        id: locationItem.id,
        active: locationItem.active[0],
        city: locationItem.hasOwnProperty('city') ? locationItem.city[0] : '', 
        state: locationItem.hasOwnProperty('state') ? locationItem.state[0] : '',
        zip: locationItem.hasOwnProperty('zip') ? locationItem.zip[0] : '',
        address: locationItem.hasOwnProperty('address') ? locationItem.address[0] : '',
        description: locationItem.hasOwnProperty('description') ? locationItem.description[0] : '',
        latitude: locationItem.latitude[0],
        locationImage:  locationItem.hasOwnProperty('locationImage') ? locationItem.locationImage[0] : '',
        locationName: locationItem.locationName[0],
        locationTypes: locationItem.locationTypes[0],
        longitude: locationItem.longitude[0],
        maxAppointmentsOther: locationItem.maxAppointmentsOther[0],
        maxAppointmentsSunday: locationItem.maxAppointmentsSunday[0],
        phone: locationItem.hasOwnProperty('phone') ? locationItem.phone[0] : '',
        hoursToday: buildStoreHours(locationItem),
        hoursMonday: locationItem.hasOwnProperty('hoursMonday') ? locationItem.hoursMonday[0] : '',
        hoursTuesday: locationItem.hasOwnProperty('hoursTuesday') ? locationItem.hoursTuesday[0] : '',
        hoursWednesday: locationItem.hasOwnProperty('hoursWednesday') ? locationItem.hoursWednesday[0] : '',
        hoursThursday: locationItem.hasOwnProperty('hoursThursday') ? locationItem.hoursThursday[0] : '',
        hoursFriday: locationItem.hasOwnProperty('hoursFriday') ? locationItem.hoursFriday[0] : '',
        hoursSaturday: locationItem.hasOwnProperty('hoursSaturday') ? locationItem.hoursSaturday[0] : '',
        hoursSunday: locationItem.hasOwnProperty('hoursSunday') ? locationItem.hoursSunday[0] : '',
        hoursWeekday: locationItem.hasOwnProperty('hoursWeekday') ? locationItem.hoursWeekday[0] : '',
        learnMoreUrl: locationItem.hasOwnProperty('learnMoreUrl') ? locationItem.learnMoreUrl[0] : '',
        services: locationItem.hasOwnProperty('services') ? locationItem.services[0] : '',
        servicesOffered: locationItem.hasOwnProperty('servicesOffered') ? locationItem.servicesOffered[0] : '',
        url: locationItem.id.replace('/locations', '').replace(/\//g, ''),
        prefLocation: isPrefLocation(locationItem.id),
        distance: locationItem.hasOwnProperty('distance')? locationItem.distance: '',
        displayHours: (locationItem.locationTypes.indexOf("In-Home") === -1 && locationItem.locationTypes.indexOf("Virtual") === -1 && locationItem.hasOwnProperty('hoursSaturday') && locationItem.hasOwnProperty('hoursSaturday')[0] !== ''),
        scheduleUrl: locationItem.locationTypes.indexOf("In-Home") != -1 ? '/pages/schedule-in-home?location=': (locationItem.locationTypes.indexOf("Retail") != -1 || locationItem.locationTypes.indexOf("Virtual") != -1) ? '/pages/schedule-your-design-consultation?location=' : '',
        scheduleUrlName: urlName
  }

  return applyStoreOverride(locationObj, storeOverrideFor(locationItem.id));
}

/*
  Overlays the stores.json record for a store onto the object built from the
  search service response. Only the fields the cards display are replaced —
  locationTypes is left alone because the caller has already bucketed the store
  into the residential/commercial list by the service's value, and coordinates
  are left alone because the distance was already computed from them.
*/
function applyStoreOverride(locationObj, override) {
  if (!override) return locationObj;

  var DAY_KEYS = {
    hoursMonday: 'monday',
    hoursTuesday: 'tuesday',
    hoursWednesday: 'wednesday',
    hoursThursday: 'thursday',
    hoursFriday: 'friday',
    hoursSaturday: 'saturday',
    hoursSunday: 'sunday'
  };

  if (override.name) locationObj.locationName = override.name;
  if (typeof override.address === 'string') locationObj.address = override.address;
  if (typeof override.city === 'string') locationObj.city = override.city;
  if (typeof override.state === 'string') locationObj.state = override.state;
  if (typeof override.zip === 'string') locationObj.zip = override.zip;
  if (typeof override.phone === 'string') locationObj.phone = override.phone;
  if (typeof override.learn_more_url === 'string') locationObj.learnMoreUrl = override.learn_more_url;
  if (typeof override.description === 'string') locationObj.description = override.description;

  if (override.hours) {
    var hoursMap = {};
    var hasAnyHours = false;
    for (var objKey in DAY_KEYS) {
      var value = override.hours[DAY_KEYS[objKey]] || '';
      locationObj[objKey] = value;
      hoursMap[objKey] = value;
      if (value) hasAnyHours = true;
    }
    locationObj.hoursWeekday = hoursMap.hoursMonday;
    locationObj.hoursToday = hasAnyHours ? buildStoreHoursFromMap(hoursMap) : '';

    var types = locationObj.locationTypes || '';
    locationObj.displayHours = hasAnyHours &&
      types.indexOf('In-Home') === -1 &&
      types.indexOf('Virtual') === -1;
  }

  return locationObj;
}

function buildStoreHours(locationItem){
  return buildStoreHoursFromMap({
    "hoursMonday": locationItem.hasOwnProperty('hoursMonday') ? locationItem.hoursMonday[0] : '',
    "hoursTuesday": locationItem.hasOwnProperty('hoursTuesday') ? locationItem.hoursTuesday[0] : '',
    "hoursWednesday": locationItem.hasOwnProperty('hoursWednesday') ? locationItem.hoursWednesday[0] : '',
    "hoursThursday": locationItem.hasOwnProperty('hoursThursday') ? locationItem.hoursThursday[0] : '',
    "hoursFriday": locationItem.hasOwnProperty('hoursFriday') ? locationItem.hoursFriday[0] : '',
    "hoursSaturday": locationItem.hasOwnProperty('hoursSaturday') ? locationItem.hoursSaturday[0] : '',
    "hoursSunday": locationItem.hasOwnProperty('hoursSunday') ? locationItem.hoursSunday[0] : '',
  });
}

function buildStoreHoursFromMap(storeHours){
  let now = new Date();

  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  let currentDay = days[now.getDay()];
  let currentHours = now.getHours();
  let currentMinutes = now.getMinutes();
    let todayHours = storeHours[`hours${currentDay}`];
    if(!isValidTimeRange(todayHours)) {
      return todayHours
    }
    let [openTimeStr, , closeTimeStr] = todayHours.split(' ');

    let { hour: openHour, minute: openMinute, period: openPeriod } = parseTime(openTimeStr);
    let { hour: closeHour, minute: closeMinute, period: closePeriod } = parseTime(closeTimeStr);
    
    if (openPeriod === "PM" && openHour !== "12") openHour = parseInt(openHour) + 12;
    if (openPeriod === "AM" && openHour === "12") openHour = 0;

    if (closePeriod === "PM" && closeHour !== "12") closeHour = parseInt(closeHour) + 12;
    if (closePeriod === "AM" && closeHour === "12") closeHour = 0;

    openHour = parseInt(openHour);
    openMinute = parseInt(openMinute);
    closeHour = parseInt(closeHour);
    closeMinute = parseInt(closeMinute);

    let currentTimeInMinutes = currentHours * 60 + currentMinutes;
    let openTimeInMinutes = openHour * 60 + openMinute;
    let closeTimeInMinutes = closeHour * 60 + closeMinute;
    

    if (currentTimeInMinutes >= openTimeInMinutes && currentTimeInMinutes <= closeTimeInMinutes) {
        let closeTimeStrFormatted = `${closeHour % 12}:${closeMinute < 10 ? '0' : ''}${closeMinute} ${closePeriod}`;
        return `Open - Closes at ${closeTimeStrFormatted}`
    } else {
        let nextOpeningDay = getNextOpeningDay(storeHours, currentDay, openHour, openTimeInMinutes, currentTimeInMinutes);
        let nextOpeningTime = storeHours[`hours${nextOpeningDay}`].split(' ')[0];
        return`Closed - Opens ${nextOpeningDay} at ${nextOpeningTime}`;
    }
}

function getNextOpeningDay(hours, currentDay,  openTimeInMinutes, currentTimeInMinutes) {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  
  for (let i = 1; i < days.length; i++) {
      let nextDay = days[(days.indexOf(currentDay) + i) % days.length];
      if(openTimeInMinutes <= currentTimeInMinutes){
        nextDay = currentDay
      }
      if (hours[`hours${nextDay}`]) {
          return nextDay;
      }
  }
  return "Monday";
}

function isValidTimeRange(timeRange) {
  const timePattern = /^\d{1,2}:\d{2}[APM]{2} to \d{1,2}:\d{2}[APM]{2}$/;
  return timePattern.test(timeRange);
}

function parseTime(timeStr) {
  let timeRegex = /(\d{1,2}):(\d{2})(AM|PM)/;
  let match = timeStr.match(timeRegex);
  
  if (!match) {
      throw new Error('Invalid time format');
  }
  
  return {
      hour: parseInt(match[1]),
      minute: match[2],         
      period: match[3]           
  };
}


function highlightTodayHours(){
  let now = new Date();
  const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  $(`.${days[now.getDay()]}-hours`).css("font-weight", "bold");
}


/*
  stores.json overlay.

  The store search service is stale for stores whose details have changed since
  it was last fed, so the published stores.json asset (the source of truth,
  written by the store manager) is fetched once and overlaid onto each search
  result: name, address, phone, hours and hours_callout. The service is still
  what decides which stores come back and supplies the coordinates used for the
  radius/distance math.

  TODO: drop the search service from this page entirely and drive the list from
  stores.json (it carries latitude/longitude per location), so there is one
  source of truth and the service can be decommissioned.
*/
var storesJsonBySlug = null;
var storesJsonRequest = null;
var pendingStoreRenders = [];

function slugFromStoreUrlId(urlId) {
  return (urlId || '').replace('/locations', '').replace(/\//g, '');
}

function loadStoresJson() {
  if (storesJsonRequest) return storesJsonRequest;
  if (!window.storesDataUrl || !window.fetch) {
    storesJsonBySlug = {};
    flushPendingStoreRenders();
    return null;
  }
  storesJsonRequest = fetch(window.storesDataUrl)
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      storesJsonBySlug = {};
      var locations = (data && data.locations) || [];
      for (var i = 0; i < locations.length; i++) {
        var slug = slugFromStoreUrlId(locations[i].url_id);
        if (slug) storesJsonBySlug[slug] = locations[i];
      }
    })
    .catch(function () {
      storesJsonBySlug = {};
    })
    .then(function () {
      flushPendingStoreRenders();
    });
  return storesJsonRequest;
}

function flushPendingStoreRenders() {
  var queued = pendingStoreRenders;
  pendingStoreRenders = [];
  for (var i = 0; i < queued.length; i++) {
    queued[i]();
  }
}

/*
  Defers a render until stores.json has resolved, so cards are never painted
  with the stale service values and then corrected. On fetch failure the map is
  set to {} and the render proceeds on service data alone.
*/
function whenStoresJsonReady(render) {
  if (storesJsonBySlug) return false;
  pendingStoreRenders.push(render);
  loadStoresJson();
  return true;
}

function storeOverrideFor(locationId) {
  if (!storesJsonBySlug) return null;
  return storesJsonBySlug[slugFromStoreUrlId(locationId)] || null;
}

function applyStoreHoursCallouts() {
  $('[data-store-callout]').each(function () {
    var $el = $(this);
    var override = storesJsonBySlug ? storesJsonBySlug[$el.attr('data-store-callout')] : null;
    var callout = override && override.hours_callout;
    if (!callout) {
      $el.empty().removeAttr('role');
      return;
    }
    $el.attr('role', 'alert').html(
      '<i class="fal fa-exclamation-circle store-hours-callout__icon" aria-hidden="true"></i>' +
      '<div class="store-hours-callout__body">' +
      '<span class="sr-only">Important notice: </span>' +
      callout.replace(/&nbsp;/g, ' ') +
      '</div>'
    );
  });
}

function compare( a, b ) {
  if ( a.distance < b.distance ){
    return -1;
  }
  if ( a.distance > b.distance ){
    return 1;
  }
  return 0;
}

function buildBusinessStoreDetails(business) {
  if (whenStoresJsonReady(function () { buildBusinessStoreDetails(business); })) return;

  var $storeDetailsContainer = $('#businessStore');
      $storeDetailsContainer.empty();
      businessData = {},
      source = $("#BusinessTemplate").html(),
      template = Handlebars.compile(source);
    var businessObj = business.map(function(businessItem) {   
      return business = buildLocationObj(businessItem);
  });
  businessObj.sort(compare);
  businessData = {
    business: businessObj
  }
  //$storeDetailsContainer.append(template1(businessData));
  $storeDetailsContainer.append(template(businessData));
  highlightTodayHours()
  applyStoreHoursCallouts()
}

function buildHomeAndRetailStoreDetails(homeAndRetail) {
  if (whenStoresJsonReady(function () { buildHomeAndRetailStoreDetails(homeAndRetail); })) return;

  var scheduleRequest = qs['isSchedulerRedirect'] ? true : false;
  var $storeDetailsContainer = $('#homeAndRetailStore');
      $storeDetailsContainer.empty();
      var source = $("#HomeAndRetailTeamplate").html(),
      homeAndRetailData = {},
      template = Handlebars.compile(source);
      var homeAndRetailObj = homeAndRetail.map(function(homeAndRetailItem) { 
        return homeAndRetail = buildLocationObj(homeAndRetailItem);
    });
    homeAndRetailObj.sort(compare);
  homeAndRetailData = {
    homeAndRetail: homeAndRetailObj,
    scheduleRequest: scheduleRequest
  }
  //$storeDetailsContainer.append(template1(businessData));
  $storeDetailsContainer.append(template(homeAndRetailData));
  highlightTodayHours()
  applyStoreHoursCallouts()
}

function setAsPrefLocation(storeData) {
  saveLocalStorage("prefLocation", storeData);
  buildHomeAndRetailStoreDetails(homeAndRetail);
  buildBusinessStoreDetails(business);
  buildHeaderPrefLocationSection();
}

function isPrefLocation(locationId) {
  var prefLocation = getLocalStorage("prefLocation");
  if(prefLocation && prefLocation.id === locationId) {
    return true;
  }
  return false;
}

function toggleStores(type) {
  $("#residentialBtn").removeClass('residentialActive');
  $("#commercialBtn").removeClass('commercialActive');
  if(type === "retail") {
    $("#homeAndRetailStore").show();
    $("#businessStore").hide();
    $("#residentialBtn").addClass("residentialActive");
  } else {
    $("#homeAndRetailStore").hide();
    $("#businessStore").show();
    $("#commercialBtn").addClass("commercialActive");
  }
}

function getPostalCode(result) {
  for (var i = 0; i < result.address_components.length; i++) {        
      for (var j = 0; j < result.address_components[i].types.length; j++) {
        if (result.address_components[i].types[j] == "postal_code") {
          zip = result.address_components[i].long_name;
        }
    }
  }
  return zip;
}

$(document).on("submit", "#locationSearch", function(e){
  if(!zip || zip === "") {
    if(qs['isCommercialSearch']) {
      console.log('isComm')
      var input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", "isCommercialSearch");
      input.setAttribute("value", "true");
      document.getElementById("locationSearch").appendChild(input);
    }
    e.preventDefault();
    console.log('submitSearch1')
    submitSearch();
  }
});

function checkAndSubmitForm() {
    $("#zipCode").val(zip);
    $("#latitude").val(latitude);
    $("#longitude").val(longitude);
    console.log(latitude,longitude,zip)
    if($("#selectDropdown").val()) {
      $("#radius").val(50);
    }
    
    if($("#isHomeSearch").val()) {  
      $.ajax({
        type: 'GET',
        url: serviceUrl + "/search/store?q=fq=(locationTypes:%22In-Home%22)",
        dataType: 'json',
        success: function(json){
          currentMiles = 100;
          postalCode = zip;
          $("#selectDropdown").val(currentMiles);
          if (json.response.docs.length > 0){
            var i,j;
            var postalcodeArr = [];
            var milesArr = [];
            var lat2 = latitude;
            var lon2 = longitude;
            for (i=0; i < json.response.docs.length; i++){
              if(json.response.docs[i].active[0] === true){
                var lat1 = json.response.docs[i].latitude;
                var lon1 = json.response.docs[i].longitude;
                // Get the Distance in KM based on Latitude and Longitude
                getDistanceFromLatLonInKm = function(lat1, lon1, lat2, lon2) {
                    var R = 3959; // Radius of the earth in miles
                    var dLat = deg2rad(lat2 - lat1); // deg2rad below
                    var dLon = deg2rad(lon2 - lon1);
                    var a =
                        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                        Math.sin(dLon / 2) * Math.sin(dLon / 2);
                    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                    var miles = R * c; // Distance in miles
                    if(Math.round(miles) <= currentMiles && json.response.docs[i].locationTypes[0] != "In-Home"){
                        json.response.docs[i].distance = miles.toFixed(1) * 1;
                        milesArr.push(json.response.docs[i]);
                    }
                    return miles.toFixed(1) * 1;
              }
                getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2);
                var zipCheck = json.response.docs[i].zip;
                  if(zipCheck && zipCheck[0] !== "" && zipCheck[0] === postalCode) {
                    postalcodeArr.push(json.response.docs[i]);  
                  }
                  var zipsWrap = json.response.docs[i].zips;
                  if(json.response.docs[i].hasOwnProperty("zips") && zipsWrap[0] !== " "){
                    for(j=0; j < zipsWrap.length; j++){
                        if(zipsWrap[j].indexOf(postalCode) !== -1){
                          //if( zipsWrap[j].indexOf(',') ){
                          var commavalue = zipsWrap[j];
                            if(commavalue === postalCode && json.response.docs[i].locationTypes[0] != "Retail"){
                                postalcodeArr.push(json.response.docs[i]);
                            }
                          //}
                        }
                    }
                  }
              }
            }
            if(postalcodeArr.length > 0 || milesArr.length > 0){
              var mergedArr = postalcodeArr.concat(milesArr);
              mergedArr = filterDuplicates(mergedArr);
              mileslimit = mergedArr;
              for(var i=0; i < mileslimit.length; i++) {
                latLongArray.push(new google.maps.LatLng(mileslimit[i].latitude,mileslimit[i].longitude));
                storeAddress.push(mileslimit[i]);
                console.log("2"+mileslimit[i].locationTypes);
                if(mileslimit[i].locationTypes == "Business"){
                  business.push(mileslimit[i]);
                } else{
                  homeAndRetail.push(mileslimit[i]);
                }
              }
              if(homeAndRetail.length > 0) {
                var inHomeItem = buildLocationObj(homeAndRetail[0])
                window.location.href = "/pages/schedule-in-home?location=" + inHomeItem.url;
              } else {
                $("#locationSearch").submit();
              }
            } else {
              $("#locationSearch").submit();
            }
          }
        },
        error: function(status){
            //$("#locationSearch").submit();
        }
    });
    } else {
      $("#locationSearch").submit();
    }
}

function submitSearch() {
  zip = "";
  const address = $("#address").val();
  const geo = new google.maps.Geocoder;
  /**
  TODO need to add this login for valid inputs
    let validInput = false;
    addressInput = address.split(',');
    if(addressInput.length > 1){
      validInput = (isNaN(addressInput[0] && isNaN(addressInput[1]))) ? true : false;
      validInput = true;
    }else if(addressInput.length==1 && !isNaN(addressInput[0]) && addressInput[0].length==5){
      validInput = true;
    }
  **/
  geo.geocode({'address':address},function(results, status){
      if (status == google.maps.GeocoderStatus.OK) {              
          const myLatLng = results[0].geometry.location;
          latitude = myLatLng.lat();
          longitude = myLatLng.lng();
          // Add some code to work with myLatLng
          zip = getPostalCode(results[0]);
          console.log('zip2='+zip)
          if(zip === "") {
            var latlng = new google.maps.LatLng(latitude, longitude);
            geo.geocode({'latLng': latlng}, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                  zip = getPostalCode(results[0]);
                  if(zip !== "" && !isNaN(zip)) {
                    checkAndSubmitForm();
                  } else {
                    console.log("Geocoder could not find postal code for this address", zip);
                    window.location = window.location.pathname +'?invalid=true'
                  }
                } else {
                  console.log("Geocoder failed due to: " + status);
                }
            });
          } else {
            checkAndSubmitForm();
          }
      } else {
          console.log("Geocode was not successful for the following reason: " + status);
      }
  });
}

$(document).ready(function(){
//console.log('ready!')
  //identify mobile vs. deskctop and remove click to call tags for those
  if(!isMobileByTouch() && !isMobileByAgent()){
      //console.log('desktop!')
      document.querySelectorAll('a[href^="tel:"]').forEach(function (link) {
      //console.log(link);
      const span = document.createElement("span");
      span.textContent = link.textContent;          // keep visible text
      span.className = link.className;              // preserve classes
      span.style.cssText = link.style.cssText;      // preserve inline styles
      span.style.pointerEvents = "none";            // make sure it's not clickable
      link.replaceWith(span);
      });
  }
});

$(window).on('load', function() {
fixMapAccessibility();
  setInterval(fixMapAccessibility, 10000);
})

function fixMapAccessibility() {
    //console.log('its time now')
    const mapImages = $('img[src*="transparent.png"]');
    mapImages.each(function() {
      console.log('working');
        if (!$(this).attr('alt')) {
            $(this).attr('alt', 'Map location marker');
            $(this).attr('title', 'Map location marker');
        }
    });
}
